import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BadgePercent, X } from "lucide-react";
import { getPromo, subscribePromo, clearPromo, promoText } from "../promo";

const HIDDEN_PATHS = ["/admin", "/payment", "/manage", "/review", "/ambassador"];
const HIDDEN_EXACT = new Set(HIDDEN_PATHS);
const isHidden = (path) =>
  HIDDEN_EXACT.has(path) || HIDDEN_PATHS.some((p) => path.startsWith(`${p}/`));

const PromoBanner = () => {
  const [promo, setPromoState] = useState(getPromo());
  const location = useLocation();

  useEffect(() => subscribePromo(setPromoState), []);

  if (!promo || isHidden(location.pathname)) return null;

  return (
    <div
      data-testid="promo-banner"
      className="fixed bottom-4 inset-x-0 z-50 flex justify-center px-4 pointer-events-none"
    >
      <div className="pointer-events-auto flex items-center gap-3 md:gap-4 border border-volt bg-[#0A0A0A]/95 backdrop-blur-md px-4 md:px-5 py-3.5 shadow-[0_10px_40px_rgba(0,0,0,0.6)]">
        <BadgePercent size={18} className="text-volt shrink-0" />
        <p className="font-plex text-[10px] md:text-xs uppercase tracking-[0.2em] text-white">
          Code <span className="text-volt">{promo.code}</span> active — {promoText(promo)} your order,
          applied at checkout
        </p>
        <button
          onClick={clearPromo}
          data-testid="promo-banner-dismiss"
          aria-label="Dismiss promo banner"
          className="text-white/40 hover:text-white transition-colors duration-200 shrink-0"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
